import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://sibgukdawotjyryfzjmt.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNpYmd1a2Rhd290anlyeWZ6am10Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxOTA1NjEsImV4cCI6MjA2NTc2NjU2MX0.oUci0vrC_hUYmQRZ75qcBITWFtBJEVw1s8g2kgOYozw'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const signInWithUsername = async (username, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: `${username}@example.com`,
    password: password,
    options: {
      expiresIn: 86400 // 24 hours in seconds
    }
  });

  if (error) throw error;

  if (data.user) {
    // Fetch current user metadata
    const { data: { user: currentUser }, error: fetchError } = await supabase.auth.getUser();
    if (fetchError) throw fetchError;

    const currentLoginCount = currentUser.user_metadata.login_count || 0;
    const newLoginCount = currentLoginCount + 1;

    // Update user metadata with new login count
    const { error: updateError } = await supabase.auth.updateUser({ 
      data: { 
        username: username,
        login_count: newLoginCount 
      } 
    });

    if (updateError) throw updateError;

    // We're not returning the login count to the component
    return { user: data.user, error: null };
  }

  return { user: null, error: new Error('Login failed') };
};
